// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixField } from './PFixField';
export class PFixObjectField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = null;
    }
    ReadValue(buffer) {
        const dataType = buffer.ReadByte();
        switch (dataType) {
            case DataType.Boolean:
                this.Value = buffer.ReadBoolean();
                break;
            case DataType.Int32:
                this.Value = buffer.ReadInt32();
                break;
            case DataType.Double:
                this.Value = buffer.ReadDouble();
                break;
            case DataType.String:
                this.Value = buffer.ReadString();
                break;
            case DataType.DateTime:
                this.Value = buffer.ReadDate();
                break;
            case DataType.Long:
                this.Value = buffer.ReadInt64();
                break;
            case DataType.Single:
                this.Value = buffer.ReadSingle();
                break;
        }
    }
    Write(buffer) {
        throw new Error('not implemented');
    }
}
var DataType;
(function (DataType) {
    DataType[DataType["Boolean"] = 0] = "Boolean";
    DataType[DataType["Int32"] = 1] = "Int32";
    DataType[DataType["Double"] = 2] = "Double";
    DataType[DataType["String"] = 3] = "String";
    DataType[DataType["DateTime"] = 4] = "DateTime";
    DataType[DataType["Long"] = 5] = "Long";
    DataType[DataType["Single"] = 5] = "Single";
})(DataType || (DataType = {}));
